import { render, staticRenderFns } from "./OnboardingUISettingsCopyStakeContent.vue?vue&type=template&id=22e84f8a&scoped=true&lang=pug"
import script from "./OnboardingUISettingsCopyStakeContent.vue?vue&type=script&lang=ts"
export * from "./OnboardingUISettingsCopyStakeContent.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingUISettingsCopyStakeContent.vue?vue&type=style&index=0&id=22e84f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e84f8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFadeTransition,VProgressLinear,VRadio,VRadioGroup,VRow})
